import './App.css';
import './Respdesign.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import { LocationProvider } from './LocationContext'; // Import the LocationProvider
import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";

//import Pages
import Home from './Pages/Home';
import Login from './Pages/Login';
import Recoverpass from './Pages/Recoverpass';
import Dashboard from './Dashboard/Dashboard';
import Academic from './Dashboard/Academic';
import AssTasks from './Dashboard/AssTasks';
import MyStartups from './Dashboard/MyStartups';
import ClientProjects from './Dashboard/ClientProjects';
import FeeReports from './Dashboard/FeeReports';
import MyProfile from './Dashboard/MyProfile';
import AiAssistant from './Dashboard/AiAssistant';
import FireflyReports from './Dashboard/FireflyReports';
import DarasaReports from './Dashboard/DarasaReports';
import EditAccount from './Dashboard/EditAccount';
import Complete from './Pages/Complete';
import ClassSession from './Dashboard/ClassSession';
import GroupCall from './Dashboard/GroupCall';
import AddStartup from './Dashboard/AddStartup';
import AddCourse from './Dashboard/AddCourse';
import MyRooms from './Dashboard/MyRooms';
import ClassCalls from './Dashboard/ClassCalls';
import VideoRoom from './Dashboard/VideoRoom';
import VideoPrecheck from './Dashboard/VideoPrecheck';
import Chat from './Dashboard/Chat';
import Interviews from './Dashboard/Interviews';
import AdmissionSteps from './Dashboard/AdmissionSteps';
import Invoices from './Dashboard/Invoices';
import ViewInvoice from './Dashboard/ViewInvoice.js';
import ViewReceipt from './Dashboard/ViewReceipt.js';
import CourseDetails from './Dashboard/CourseDetails.js';
import StudentPerformance from './Dashboard/StudentPerformance.js';
import StudentId from './Dashboard/StudentId.js';
import StudentTrainee from './Dashboard/StudentTrainee.js';
import NorthstarHub from './Dashboard/NorthstarHub.js';
import StudentsPathways from './Dashboard/StudentsPathways.js';
import WorkspaceUpdatesPage from './Dashboard/WorkspaceUpdatesPage';


import { getDatabase, ref, onDisconnect, set } from "firebase/database";
import { app } from './firebase.js';
import JobBoard from './Dashboard/JobBoard.js';
import StartupCorner from './Dashboard/StartupCorner.js';
import HowItWorks from './Pages/HowItWorks.js';
import Features from './Pages/Features.js';
import LearningOutcomes from './Pages/LearningOutcomes.js';
import Downloads from './Pages/Downloads.js';
import Workspace from './Dashboard/Workspace.js';

function RequireLogin({ children }) {
  const auth = getAuth();
  const location = useLocation();
  const [authReady, setAuthReady] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user || null);
      setAuthReady(true);
    });

    return () => unsubscribe();
  }, [auth]);

  if (!authReady) {
    return null;
  }

  if (!currentUser) {
    const redirectPath = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />;
  }

  return children;
}

function App() {

  const auth = getAuth();

  useEffect(() => {
    const db = getDatabase(app);
    // Listen for changes in authentication state
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const userId = user.uid;
        const userStatusRef = ref(db, `/status/${userId}`);

        // User is online
        const onlineStatus = {
          state: "online",
          last_changed: Date.now(),
          userId:userId
        };

        const offlineStatus = {
          state: "offline",
          last_changed: Date.now(),
          userId:userId
        };

        // Set user as online when connected
        set(userStatusRef, onlineStatus);

        // Set user as offline automatically when disconnected
        onDisconnect(userStatusRef).set(offlineStatus);
      }
    });
  }, [auth]);

  return (
    <div>
        <LocationProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<Recoverpass />} />
              <Route path="/recover" element={<Recoverpass />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/features" element={<Features />} />
              <Route path="/student-experience" element={<LearningOutcomes />} />
              <Route path="/downloads" element={<Downloads />} />

              {/* STUDENTS ACCOUNT */}
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="interviews" element={<Interviews />} />
              <Route path="interviews/:meetingId" element={<Interviews />} />
              <Route path="admission-steps" element={<AdmissionSteps />} />
              <Route path="academic" element={<Academic />} />
              <Route path="tasks" element={<AssTasks />} />
              <Route path="startups" element={<MyStartups />} />
              <Route path="assigned-profects" element={<ClientProjects />} />
              <Route path="fee-report" element={<FeeReports />} />
              <Route path="class-reports" element={<DarasaReports />} />
              <Route path="ai-assistant" element={<AiAssistant />} />
              <Route path="ubunifu-firefly" element={<AiAssistant />} />
              <Route path="firefly-reports" element={<FireflyReports />} />
              <Route path="profile" element={<MyProfile />} />            
              <Route path="edit-profile" element={<EditAccount />} />
              <Route path="complete" element={<Complete />} />
              <Route path="onsession" element={<ClassSession />} />
              <Route path="group-call" element={<GroupCall />} />
              <Route path="add-startup" element={<AddStartup />} />
              <Route path="add-course" element={<AddCourse />} />
              <Route path="my-rooms" element={<MyRooms />} />
              <Route path="class-session" element={<ClassCalls />} />
              <Route path="video-call" element={<VideoPrecheck />} />
              <Route path="video-call/room" element={<VideoRoom />} />
              <Route path="chat" element={<Chat />} />
              <Route path="fee-invoices" element={<Invoices />} />
              <Route path="messages" element={<RequireLogin><Workspace /></RequireLogin>} />
              <Route path="startup-corner" element={<StartupCorner />} />
              <Route path="job-board" element={<JobBoard />} />
              <Route path="view-receipt" element={<ViewReceipt />} />
              <Route path="view-invoice" element={<ViewInvoice />} /> 
              <Route path="course-details" element={<CourseDetails />} />
              <Route path="student-performance" element={<StudentPerformance />} />
              <Route path="student-id" element={<StudentId />} />
              <Route path="student-trainee" element={<StudentTrainee />} />
              <Route path="students-pathways" element={<StudentsPathways />} />
              <Route path="northstar-hub" element={<NorthstarHub />} />
              <Route path="workspace" element={<RequireLogin><Workspace /></RequireLogin>} />
              <Route path="workspace/updates" element={<RequireLogin><WorkspaceUpdatesPage /></RequireLogin>} />
              <Route path="teams" element={<RequireLogin><Workspace /></RequireLogin>} />
            </Routes>       
          </BrowserRouter>    
        </LocationProvider> 
    </div>
  );
}

export default App;
